function Plus (props) {

  const {
    color =  "#252525",
    fill = "none",
    width = "24",
    height = "24",
  } = props

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2V22" stroke= {color} />
      <path d="M2 12L22 12" stroke= {color}  />
    </svg>
  )
}

export default Plus;